import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Card.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'post /user/cards': 200,
    // 'get /user/cards': 200,
    // 'delete /user/cards': 200,
  })
}

export const getAllBannerCards = () => {}
